import { useEffect, useState } from "react";
import Loading from "../../components/Loading";
import FancyDate from "../../components/FancyDate";
import { motion } from "framer-motion";

import { FancyDatePicker } from "../../components/ui/fancydatepicker";
import { IDaily, IDailyRecord } from "../../lib/types";
import Container from "../../components/Container";

import Button from "../../components/form/button";
import { _Classes } from "../../lib/styles";
import { fullDate } from "../../lib/utils";
import DailyTodos from "../../components/studio/daily/DailyTodos";
import pb from "../../lib/pocketbase";

import { Helmet } from "react-helmet";
import { Input } from "../../components/ui/input";

function Daily() {
    const [loading, setLoading] = useState(true);
    const [todos, setTodos] = useState<IDailyRecord[]>([]);
    const today = new Date();

    const [date, setDate] = useState<Date>(today);
    const [newTodo, setNewTodo] = useState<string>("");

    async function load() {
        const records: IDailyRecord[] = await pb.collection("daily").getFullList({
            sort: "created"
        });

        pb.collection("daily").subscribe<IDailyRecord>("*", function (e) {
            console.log(e.action);
            if (e.action === "update") {
                setTodos((prev) =>
                    prev.map((todo) => {
                        return todo.id === e.record.id ? e.record : todo;
                    })
                );
                return;
            } else if (e.action === "create") {
                setTodos((prev) => [...prev, e.record]);
                return;
            } else if (e.action === "delete") {
                setTodos((prev) => prev.filter((todo) => todo.id !== e.record.id));
                return;
            }
        });

        setTodos(records);
        setLoading(false);
    }

    useEffect(() => {
        load();
    }, []);

    function nextDay() {
        const newDate = new Date((date || today).setDate((date || today).getDate() + 1));
        setDate(newDate);
    }

    function prevDay() {
        const newDate = new Date((date || today).setDate((date || today).getDate() - 1));
        setDate(newDate);
    }

    async function addTodo() {
        if (newTodo.trim() !== "") {
            let todo: IDaily = {
                text: newTodo,
                completed: false,
                date: fullDate(date || today),
                description: ""
            };
            setNewTodo("");
            const x: IDailyRecord = await pb.collection("daily").create({
                ...todo,
                user: pb.authStore.model?.id
            });
            setTodos([...todos, x]);
        }
    }

    const [selectDate, setSelectDate] = useState(false);

    useEffect(() => {
        setTimeout(() => {}, 3000);
        setSelectDate(false);
    }, [date]);

    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Daily</title>
            </Helmet>
            <Container variant={"extra-small"} className="mt-4 md:my-8 lg:my-14">
                {pb.authStore.isValid && (
                    <section className="text-slate-600 dark:text-slate-200">
                        <div className="flex h-24 items-center">
                            <Button size="ghost" variant="ghost" onClick={() => prevDay()}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="h-6 w-6 text-slate-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-200 focus-visible:ring-offset-2 disabled:cursor-not-allowed  disabled:opacity-50 dark:text-slate-700 dark:ring-offset-slate-900 focus-visible:dark:ring-slate-700">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                                </svg>
                            </Button>
                            <div className="flex flex-grow justify-center">
                                {selectDate ? (
                                    <FancyDatePicker date={date || today} setDate={setDate}>
                                        <FancyDate date={date || today} />
                                    </FancyDatePicker>
                                ) : (
                                    <>
                                        {/* @ts-ignore */}
                                        <motion.button onClick={() => setSelectDate(true)} key={date || today} initial={{ x: 200, opacity: 0 }} animate={{ x: 0, opacity: 1 }} exit={{ x: -300, opacity: 0 }}>
                                            <FancyDate date={date || today} />
                                        </motion.button>
                                    </>
                                )}
                            </div>
                            <Button size="ghost" variant="ghost" onClick={() => nextDay()}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="h-6 w-6 text-slate-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-200 focus-visible:ring-offset-2 disabled:cursor-not-allowed  disabled:opacity-50 dark:text-slate-700 dark:ring-offset-slate-900 focus-visible:dark:ring-slate-700">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                </svg>
                            </Button>
                        </div>
                        <div className="mt-8 flex gap-2">
                            <Input value={newTodo} onKeyUp={(e) => e.key === "Enter" && addTodo()} placeholder="What do you wanna get done?" type="text" onChange={(e) => setNewTodo(e.target.value)}></Input>
                            <Button variant="outline" size="box" onClick={() => addTodo()}>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
                                </svg>
                            </Button>
                        </div>
                        {!loading && <DailyTodos todos={todos} setTodos={setTodos} date={date} />}

                        {loading && (
                            <div className="mt-4">
                                <Loading />
                            </div>
                        )}
                    </section>
                )}
            </Container>
        </>
    );
}

export default Daily;
